import * as React from 'react';

import ZoneUpsellComponent from './zone-upsell';
import { ZoneUpsell } from '../../../classes/zone-upsell';
import { Level } from '../../../classes/level';
import { Seat, CartSeat, SeatPriceQuantity } from '../../../classes/seat';
import { selectMinPrice, selectMaxPrice } from '../../../filter/actions/price-range-actions';
import { selectVenueLevel, resetVenueLevels } from '../../../filter/actions/filter-actions';
import { fetchSeatMap, getSeatViewUrl } from '../../actions/seatmap-fetch';
import { unselectSeat, openSeatmapFilters, selectZoneUpsell } from '../../actions/seatmap-actions';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import { getCurrencyFormat } from '../../../helpers/currency-format';
//import { fetchSeatView } from '../../actions/upsell-fetch';


export interface IZoneUpsellContainerProps {
    selectedPriceTypeQuantities: Array<SeatPriceQuantity>;
    venueLevels: Array<Level>;
    zoneUpsell: ZoneUpsell;
    dispatch: any;
    seats: Array<Seat>;
    cartSeats: Array<CartSeat>;
    appSettingsModel: IAppSettingsModel;
    onCloseZoneUpsell: () => any;
}

interface IZoneUpsellContainerState {
    zoneUpsellSeatView: string;
    loadingImage: boolean;
    mobileCartOpen: boolean;
    disableCart: boolean;
}

class ZoneUpsellContainer extends React.Component<IZoneUpsellContainerProps, IZoneUpsellContainerState>{
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            zoneUpsellSeatView: null,
            loadingImage: false,
            mobileCartOpen: false,
            disableCart: false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.reloadSeatView();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps: IZoneUpsellContainerProps, prevState: IZoneUpsellContainerState) {
        if (this.isNewUpsell(prevProps)) {
            this.reloadSeatView();
        }
    }

    reloadSeatView() {
        if (this.props.zoneUpsell.newZoneSeatPathId != null) {
            this.setState({ ...this.state, loadingImage: true })
            var zoneImageSrc = getSeatViewUrl(this.props.zoneUpsell.newZoneImageViewId);
            if (this._isMounted) {

                this.setState({
                    ...this.state,
                    zoneUpsellSeatView: zoneImageSrc,
                    loadingImage: false
                })
            }
        }
    }

    _onUpsellClick = () => {
        this.props.dispatch(selectZoneUpsell());
        this.props.dispatch(selectMinPrice(this.props.zoneUpsell.newZoneMinPrice));
        this.props.dispatch(selectMaxPrice(this.props.zoneUpsell.newZoneMaxPrice));
        this.props.dispatch(resetVenueLevels());
        this.props.dispatch(selectVenueLevel(this.getUpsellVenueLevel().levelNumber));
        this.props.dispatch(fetchSeatMap('', this.props.cartSeats, false, []));
        this.props.dispatch(openSeatmapFilters());

        this.props.dispatch(unselectSeat());
    };

    _onClose = () => {
        this.props.onCloseZoneUpsell();
    };

    _expandMobileCart() {
        const newState = {
            ...{},
            ...this.state,
            mobileCartOpen: !this.state.mobileCartOpen
        };

        this.setState(newState as any);
    }

    getUpsellVenueLevel(): Level {
        return this.props.venueLevels.filter(level => level.seatmapId === this.props.zoneUpsell.newZoneSeatmapId)[0];
    }

    isNewUpsell(prevProps: IZoneUpsellContainerProps) {
        return prevProps.zoneUpsell.currentZoneId != this.props.zoneUpsell.currentZoneId
            || prevProps.zoneUpsell.newZoneSeatId != this.props.zoneUpsell.newZoneSeatId
            || prevProps.zoneUpsell.newZoneSeatmapId != this.props.zoneUpsell.newZoneSeatmapId
            || prevProps.zoneUpsell.newZoneSeatPathId != this.props.zoneUpsell.newZoneSeatPathId
            || prevProps.zoneUpsell.priceTypeId != this.props.zoneUpsell.priceTypeId;
    }

    getPrice(): string {
        var filteredZonePrice = this.props.selectedPriceTypeQuantities
            .filter(ptQ => ptQ.seatPricing.priceTypeId === this.props.zoneUpsell.priceTypeId);

        if (this.props.selectedPriceTypeQuantities.length > 0 && filteredZonePrice.length > 0) {
            const difference = (this.props.zoneUpsell.newPrice - filteredZonePrice[0].seatPricing.price);
            const currencyPrice = getCurrencyFormat(this.props.appSettingsModel.currencyFormat, difference, true);
            return `${currencyPrice}`;
        } else {
            return '';
        }
    }

    getUpsellMessage(): string {
        return this.props.appSettingsModel.upsellMessageText.replace("{ZoneDescription}", this.getPrice());
    }

    render() {
        return <ZoneUpsellComponent
            {...this.props.appSettingsModel}
            loadingImage={this.state.loadingImage}
            mobileCartOpen={this.state.mobileCartOpen}
            onCloseZoneUpsell={this._onClose}
            onUpsellClick={this._onUpsellClick}
            priceText={this.getPrice()}
            upsellMessage={this.getUpsellMessage()}
            zoneUpsellName={this.props.zoneUpsell.newZoneDescription}
            zoneUpsellSeatView={this.state.zoneUpsellSeatView}
        />
    }

    // use if we want zone upsell to have open seat view capabilities
    //  <SeatInfoImage {...this.props} imageClass={"zone-upsell-content-image"} loadingSeatView={this.state.loadingImage} seatViewImageSrc={this.state.zoneUpsellSeatView} />

}

export default ZoneUpsellContainer;